import React, {Component} from 'react';

class Zona extends Component{

	constructor(props){
		super(props);
		this.fecha = props.fecha;
		this.sector = props.sector;
		this.tuneles = props.tuneles;
		this.actID = props.actID;
		//console.log("Tuneles data=", this.tuneles);
	}

	render(){
		return (
			<>
				<td> {this.fecha.toDate().toLocaleDateString()} </td>
				<td> {this.sector} </td>
				<td> {this.tuneles.tunel1.tunel}<br></br>
                     {this.tuneles.tunel2.tunel}<br></br>
                     {this.tuneles.tunel3.tunel}<br></br>
                </td>
                <td> {this.tuneles.tunel1.cama}<br></br>
                     {this.tuneles.tunel2.cama}<br></br>
                     {this.tuneles.tunel3.cama}<br></br>
                </td>
                <td> {this.tuneles.tunel1.H1}<br></br>
                     {this.tuneles.tunel2.H1}<br></br>
                     {this.tuneles.tunel3.H1}<br></br>
                </td>
                <td> {this.tuneles.tunel1.H2}<br></br>
                     {this.tuneles.tunel2.H2}<br></br>
                     {this.tuneles.tunel3.H2}<br></br>
                </td>
                <td> {this.tuneles.tunel1.H3}<br></br>
                     {this.tuneles.tunel2.H3}<br></br>
                     {this.tuneles.tunel3.H3}<br></br>
        </td>
			</>
		);
	}
}

export default Zona;